import { webKnots } from 'src/features/atoms/glove/drawer/common/back/lace/webKnots'
import { middleSidePartOfWeb, topSidePartOfWeb } from './parts/sideParts'
import { verticalPartOfWebWithLace, verticalPartOfWebWithLaceWithEdgeForDouble } from './parts/verticalParts'

export const crossDoubleWebWithLace = async (
  ctx: CanvasRenderingContext2D,
  laceColor: string,
  stitchColor: string,
  webColor: string,
  webColor2?: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  // 横上パーツ
  await topSidePartOfWeb(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
  // 横下パーツ
  await middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -20, 35, -5, 1.02, printLeatherTypeValue)
  await middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, 70, 175, -5, 0.8, printLeatherTypeValue)
  await verticalPartOfWebWithLace(ctx, webColor2 || webColor, laceColor, stitchColor, printLeatherTypeValue)
  webKnots(ctx, laceColor, -80, 90) // クロス中央の結び目
  webKnots(ctx, laceColor, -105, 110) // 捕球面上のウェブ結び目
}

export const crossDoubleWebWithLaceWithEdge = (
  ctx: CanvasRenderingContext2D,
  webColor: string,
  edgeColor: string,
  laceColor: string,
  stitchColor: string
): void => {
  // 横上パーツ
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
  // 横下パーツ
  middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -20, 35, -5, 1.02)
  middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, 70, 175, -5, 0.8)
  verticalPartOfWebWithLaceWithEdgeForDouble(ctx, webColor, edgeColor, laceColor, stitchColor)
  webKnots(ctx, laceColor, -80, 90) // クロス中央の結び目
  webKnots(ctx, laceColor, -105, 110) // 捕球面上のウェブ結び目
}
